<template>
  <div>
   <admin-change-rolesandusers ref="changeApprovalUserRole" :userRoleId="mainUserRoleId" :disabled="disableEditing" :creating="creating"></admin-change-rolesandusers>
    <br />
    <el-alert v-if="alertTitle !== ''"
      :title="alertTitle"
      :type="alertType"
      :description="callInfo"
      :closable="false"
      show-icon>
    </el-alert>
    <button class="btn btn-primary" @click="create()" :disabled="disableEditing">Create Approval User Role</button>
    <br />
    <div v-if="isLoading">
      User Role Creation Processing...
    </div>
  </div>
</template>

<script>

import router from '@/router'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'createApprovalUserRole',
  data () {
    return {
      isLoading: false,
      callInfo: '',
      alertType: '',
      alertTitle: '',
      mainUserRoleId: 0,
      approvalUserRoleValidState: false,
      disableEditing: true,
      creating: true
    }
  },
  created: function () {
    this.$on('createUserRoleValidation', function (value) {
      this.approvalUserRoleValidState = value
      this.isLoading = false
    })
    this.startUp()
  },
  methods: {
    startUp () {
      if (this.$store.getters.isAdmin) {
        // creating new role so can edit
        this.disableEditing = false
      } else {
        this.disableEditing = true
      }
    },
    create () {
      this.isLoading = true
      this.alertTitle = ''
      // check forms
      var formValid = false
      this.checkFormValidation()
      if (this.approvalUserRoleValidState === true) {
        formValid = true
      }
      if (formValid) {
        const loading = this.$loading({
          lock: true,
          text: 'Processing',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$refs.changeApprovalUserRole.formSubmit().then(response => {
          this.mainUserRoleId = response.data.id
          this.isLoading = false
          loading.close()
          this.disableEditing = true
          helperMethods.showNotification(this, 'Approval User Role Successfully Created!', 'Approval User Role Created', 'success', 10000)
          router.push('changeApprovalUserRole/' + this.mainUserRoleId)
        }).catch(reject => {
          this.isLoading = false
          this.disableEditing = false
          loading.close()
          helperMethods.showNotification(this, 'Error creating Approval User Role', reject.body, 'error', 30000)
        })
      }
    },
    checkFormValidation () {
      this.$refs.changeApprovalUserRole.checkIfValid()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
